module.exports = __webpack_public_path__ + "img/male.d6d7355f.png";